import { useRouter } from "next/router";

interface Params {
  action: string;
  key: string;
  value?: string;
}

/*
  URLSearchParams.delete(k) with value parameter method is not supported by some browsers
  https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams/delete
* */
const queryParams = () => {
  const router = useRouter();
  const params: { [key: string]: any } = new URLSearchParams(location.search);

  return (values: Params[]) => {
    values.forEach((param) => {
      if (param.action === "delete") {
        params.delete(param.key);
      }

      if (param.action === "set") {
        params.set(param.key, param.value);
      }
    });

    const pathname = window.location.pathname;

    router.push({ pathname: pathname, search: params.toString() });
  };
};

export default queryParams;
